import { useTooltipState } from '@unmind/design-system-components-web';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputSize } from 'Shared/Form';
import {
  FormikInput,
  validateEmail,
  validateFieldNotEmpty,
} from 'Shared/Form/Formik';
import { GridItem } from 'Shared/Grid';
import { ParseKeys } from 'i18next';
import * as S from '../Profile.styles';

const InputWrapper = ({
  id,
  translationKey,
  value,
  disabled = false,
  tooltip = null,
}: {
  id: string;
  translationKey: string;
  value: string;
  disabled?: boolean;
  tooltip?: React.ReactNode;
}) => {
  const { t: translate } = useTranslation('account');
  const { handlers: tooltipHandlers } = useTooltipState();

  const fieldLabel = (
    <S.FieldLabel htmlFor={id}>
      {translate(
        `profile.${translationKey}_input_label` as ParseKeys<'account'>,
      )}
    </S.FieldLabel>
  );

  return (
    <GridItem sm={4} md={4} lg={6}>
      <S.FormField>
        {tooltip ? (
          <S.TooltipContainer {...tooltipHandlers}>
            <S.FieldLabelWrapper>{fieldLabel}</S.FieldLabelWrapper>
            {tooltip}
          </S.TooltipContainer>
        ) : (
          fieldLabel
        )}
        <FormikInput
          id={id}
          inputSize={InputSize.regular}
          type={id === 'emailAddress' ? 'email' : undefined}
          name={id}
          value={value}
          disabled={disabled}
          validate={e =>
            id === 'emailAddress'
              ? validateEmail(
                  e,
                  translate(
                    `profile.validation.${translationKey}` as ParseKeys<'account'>,
                  ),
                )
              : validateFieldNotEmpty(
                  e,
                  translate(
                    `profile.validation.${translationKey}` as ParseKeys<'account'>,
                  ),
                )
          }
        />
      </S.FormField>
    </GridItem>
  );
};

export default InputWrapper;
